import React from 'react';
import useTools from '../../hooks/useTools';
import Tool from './Tool';
import bannerFive from '../../assets/banner/banner (10).jpg'
import './Tools.css'
import FeaturedProducts from './FeaturedProducts';

const Tools = () => {
    const [tools, setTools] = useTools();

    return (
        <section className='tools-section bg-accent'>
            <div>
                <h1 className='text-2xl font-bold mb-10'>Hunt <span className='text-underline'>Your Best Tools</span></h1>
            </div>

            <div className='tool-containers'>
                {
                    tools.map(tool =>
                        <Tool key={tool._id} tool={tool} >
                        </Tool>)
                }
            </div>

            <div className='mt-12 lg:mt-20 border overflow-hidden border-[#ffd000]'>
                <img className='block mx-auto zoom-img' src={bannerFive} alt="" />
            </div>
            <FeaturedProducts></FeaturedProducts>
        </section>
    );
};

export default Tools;